import { useTranslation } from 'react-i18next';

import MyButton from '../../../shared-components/button/Button';

interface DeleteUserProperties {
  title: string;
  subTitle: string;
  closeModal: () => void;
  conformSubmit?: () => void;
  submitButton?: JSX.Element;
}

/**
 * Confirm Box function component
 * @param {any} properties - Properties
 * @returns {any} Delete user component
 */
function DeleteUser(properties: DeleteUserProperties) {
  const { title, subTitle, closeModal, conformSubmit = () => {}, submitButton } = properties;
  const { t } = useTranslation('userRole');
  return (
    <div className="modal-box-body">
      <div className="conform-box-body">
        <div className="title">{title}</div>
        <div className="sub-title">{subTitle}</div>
      </div>
      <div className="form-field table-bottom-button-list form-bottom-button">
        <div className="table-button-item">
          <MyButton label={t('cancel')} buttonType="back" onClickFunc={closeModal} />
        </div>
        <div className="table-button-item">
          {submitButton || (
            <MyButton label={t('ok')} buttonType="submit" onClickFunc={() => conformSubmit()} />
          )}
        </div>
      </div>
    </div>
  );
}

DeleteUser.defaultProps = {
  submitButton: null,
  /**
   * Conform submit function
   */
  conformSubmit: () => {},
};

export default DeleteUser;
